<template>
	<base-modal
		ref="$modal"
		:height="490"
		:width="572"
	>
		<div class="chat-attached-messages">
			<app-loader v-if="isLoading"/>
			<template v-else>
				<div
					v-for="message in messages"
					:key="message.Id"
					class="chat-attached-messages__item"
					:style="{ paddingLeft: `${message.Level * 8}px` }"
				>
					<div class="chat-attached-messages__item-label" />
					<div class="chat-attached-messages__item-body">
						<div class="chat-attached-messages__item-body-header">
							<div class="chat-attached-messages__item-body-header-name">
								{{ message.Sender.Name }}
							</div>
							<div class="chat-attached-messages__item-body-header-date">
								{{ getDialogDate(message.Date) }}
							</div>
						</div>
						<div class="chat-attached-messages__item-body-text">
							{{ messageText(message) }}
						</div>
					</div>
				</div>
			</template>
		</div>
	</base-modal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppLoader from "@/components/ui-kit/loader/AppLoader.vue";
import moment from "moment";
import {ChatsApi} from "@/ api/ChatsApi";
import {AttachedMessage} from "@/store/chats";
import {applyChatMessagePlaceholders} from "@/utils/textHelpers";

const isLoading = ref(false);
const messages = ref<AttachedMessage[] | null>(null)
const $modal = ref<typeof BaseModal | null>(null)

const onOpen = async (messageId: number) => {
	$modal.value?.onOpen();

	try {
		isLoading.value = true;
		messages.value = await ChatsApi.getAttachedMessages(messageId)
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false;
	}
}

const getDialogDate = (date: string) => moment(date).format("DD.MM.YYYY HH:mm");

// текст выводится интерполяцией, а не через v-html — подставляем плейсхолдеры без разметки
const messageText = (message: AttachedMessage) =>
	applyChatMessagePlaceholders(message.Text ?? '', message.Links, message.Bills, { plainText: true });

defineExpose({ onOpen })
</script>

<style lang="scss" scoped>
.chat-attached-messages {
	display: flex;
	flex-direction: column;
	position: relative;
	gap: 4px;
	height: 100%;
	width: 100%;
	padding: 8px;
	overflow: auto;

	&__item {
		display: flex;

		&-label {
			display: flex;
			min-width: 2px;
			max-width: 2px;
			min-height: 100%;
			border-top-left-radius: 4px;
			border-bottom-left-radius: 4px;
			background-color: #3F884F;
			margin-right: 4px;
		}

		&-body {
			display: flex;
			flex-direction: column;
			width: 100%;
			color: #4D4D4D;

			&-header {
				display: flex;
				align-items: center;
				position: relative;
				gap: 4px;
				margin-bottom: 2px;

				&-name {
					font-size: 14px;
					line-height: 18px;
					font-weight: 500;
					color: #4D4D4D;
				}

				&-date {
					font-size: 12px;
					line-height: 16px;
					color: #979797;
				}
			}

			&-text {
				font-size: 14px;
				line-height: 15px;
			}
		}
	}
}
</style>
